export const USER_PROMO_CODE = 'userPromoCode';
export const DISABLED_FIELDS = [USER_PROMO_CODE];
